import React from 'react';
import classnames from 'classnames';
import {map} from 'lodash';
import Icon from 'shared/components/icon';

interface Row {
  highlighted?: boolean;
  name: string;
  values: React.ReactNode[];
  className?: string;
}

interface Props {
  caption?: React.ReactNode;
  className?: string;
  subCaption?: string;
  rows: Row[];
  header?: React.ReactNode[];
  'aria-label'?: string;
}

const StatisticsTable = ({
  rows,
  header,
  caption,
  className,
  subCaption,
  'aria-label': ariaLabel,
}: Props) => {
  const renderHeader = (tableHeader?: React.ReactNode[]) => {
    if (!tableHeader) {
      return null;
    }

    return (
      <thead className="statistics-table-header">
        <tr>
          {map(tableHeader, (title, index) => (
            <th key={index} className="statistics-table-header-title">
              {title}
            </th>
          ))}
        </tr>
      </thead>
    );
  };

  if (rows.length === 0) {
    return null;
  }

  return (
    <table
      className={classnames('college-profile-statistics-table', className)}
      aria-label={ariaLabel}
    >
      {caption && (
        <caption
          className={classnames('college-profile-statistics-table-caption', {
            only: !subCaption,
          })}
        >
          {caption}
          {subCaption && (
            <div className="college-profile-statistics-table-sub-caption">{subCaption}</div>
          )}
        </caption>
      )}

      {renderHeader(header)}

      <tbody>
        {map(rows, (row, index) => {
          const {highlighted, name, values, className: rowClassName} = row;

          return (
            <tr key={index} className={classnames('statistics-table-row', {highlighted})}>
              <th scope="row" className={`statistics-table-name ${rowClassName || ''}`}>
                {highlighted && <Icon iconType="star" className="statistics-table-row-icon" />}
                {name}
              </th>

              {map(values, (value, i) => (
                <td key={i} className={`statistics-table-value ${rowClassName || ''}`}>
                  {value}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default StatisticsTable;
